import {memo} from 'react';

import styled, {css, DefaultTheme, FlattenInterpolation, ThemedStyledProps} from 'styled-components';

import {body13Normal, body12Normal} from '~/shared/theme/typography';

import {flipOnLTR} from '../../../theme/flipOnLTR';

const labelLegacyStyles = css<{float?: boolean}>`
  ${body13Normal}
  top: calc(100% - 13px - 8px);
  line-height: 13px;
  ${flipOnLTR`
    right: 8px;
    text-align: right;
  `}
  ${({float}) => float && `
    top: 6px;
    ${body12Normal}
  `};
`;

const Label = styled.label<{
  error?: boolean;
  disabled?: boolean;
  float?: boolean;
  styleOverrides?: FlattenInterpolation<ThemedStyledProps<{float?: boolean}, DefaultTheme>>;
}>`
  position: absolute;
  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1;
  color: ${({theme, error}) => (error ? theme.colors.error : theme.colors.text)};
  ${({disabled}) => disabled && `
    opacity: 0.5;
  `};
  ${({styleOverrides}) => (styleOverrides || labelLegacyStyles)}
`;

type FormInputLabelProps = {
  htmlFor?: string;
  error?: boolean;
  disabled?: boolean;
  float?: boolean;
  required?: boolean;
  text?: string;
  labelStyleOverrides?: FlattenInterpolation<ThemedStyledProps<{float?: boolean}, DefaultTheme>>;
  omitStarSymbolOnRequired?: boolean;
};

const FormInputLabel = ({
  htmlFor,
  error,
  disabled,
  float,
  required,
  text,
  labelStyleOverrides,
  omitStarSymbolOnRequired,
}: FormInputLabelProps) => {
  const labelProps = {htmlFor, error, disabled, float};
  return (
    <Label
      {...labelProps}
      styleOverrides={labelStyleOverrides}
    >
      {`${required && !omitStarSymbolOnRequired ? '* ' : ''}${text}`}
    </Label>
  );
};

export default memo(FormInputLabel);
